import axios from 'axios'
import {UposlenikModel, Option} from '../models/UposlenikModel'
import {getAuth} from '../modules/auth'
import {Odjel} from '../models/Odjel'

const API_URL = process.env.REACT_APP_API_URL
const API = `${API_URL}/odjel`
const SELECT = `${API_URL}/odjelDropdown`
const auth: UposlenikModel = getAuth()!
const headers = {Accept: 'application/json', Authorization: `Bearer ${auth?.access_token ?? ''}`}

// Get request for Odjel dropdown data.
export async function getOdjel() {
  return await axios.get<Array<Option>>(SELECT, {headers: headers})
}

export async function getAllOdjel(pageNo: number, perPage: number) {
  const params = {per_page: perPage, page: pageNo}
  return await axios.get<Array<Odjel>>(API, {headers: headers, params: params})
}

export async function saveOdjel(Data: any) {
  try {
    const response = await axios.post(API, Data, {headers: headers})
    if (response.data && response.data.error === 0) {
      return response.data
    } else {
      // Handle any other type of response structure or errors returned from the server here
      throw new Error(response.data.message || 'Failed to fetch.')
    }
  } catch (error) {
    console.error('Error fetching Odjel data:', error)
    throw error // Re-throw the error so it can be handled by the caller if necessary
  }
}

export async function fetchOdjel(Id: number): Promise<Partial<Odjel>> {
  try {
    const response = await axios.get(`${API}/${Id}`)
    if (response.data && response.data.error === 0) {
      return response.data.data
    } else {
      // Handle any other type of response structure or errors returned from the server here
      throw new Error(response.data.message || 'Failed to fetch.')
    }
  } catch (error) {
    console.error('Error fetching Odjel data:', error)
    throw error // Re-throw the error so it can be handled by the caller if necessary
  }
}

export async function updateOdjel(Data: any, id: number) {
  try {
    const response = await axios.post(`${API}/${id}?_method=PATCH`, Data, {headers: headers})
    if (response.data && response.data.error === 0) {
      return response.data
    } else {
      // Handle any other type of response structure or errors returned from the server here
      throw new Error(response.data.message || 'Failed to update odjel.')
    }
  } catch (error) {
    console.error('Error Updates Odjel data:', error)
    throw error // Re-throw the error so it can be handled by the caller if necessary
  }
}

export async function deleteOdjel(Id: number) {
  try {
    const response = await axios.delete(`${API}/${Id}`, {headers: headers})
    if (response.data && response.data.error === 0) {
      return response
    } else {
      // Handle any other type of response structure or errors returned from the server here
      throw new Error(response.data.message || 'Failed to delete Boja.')
    }
  } catch (error) {
    console.error('Error deleting Odjel data:', error)
    throw error // Re-throw the error so it can be handled by the caller if necessary
  }
}
